module.exports = __webpack_public_path__ + "img/stock7.0f16a5a2.png";